// extracted by mini-css-extract-plugin
export var button = "NavbarDesktop-module--button--bc1ec";
export var inner = "NavbarDesktop-module--inner--ac93c";
export var isActive = "NavbarDesktop-module--isActive--50e05";
export var isDark = "NavbarDesktop-module--isDark--432a7";
export var isHighlighted = "NavbarDesktop-module--isHighlighted--49957";
export var logoContainer = "NavbarDesktop-module--logoContainer--c5125";
export var wrapper = "NavbarDesktop-module--wrapper--ed287";